import { Instance } from 'mobx-state-tree';
import { DriverInviteDtoModelBase } from './DriverInviteDtoModel.base';

/* The TypeScript type of an instance of DriverInviteDtoModel */
export interface DriverInviteDtoModelType extends Instance<typeof DriverInviteDtoModel.Type> {}

/* A graphql query fragment builders for DriverInviteDtoModel */
export { selectFromDriverInviteDto, driverInviteDtoModelPrimitives, DriverInviteDtoModelSelector } from './DriverInviteDtoModel.base';

/**
 * DriverInviteDtoModel
 */
export const DriverInviteDtoModel = DriverInviteDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
